import Images from 'app/assets/img';
import { ReactComponent as BedIcon } from 'app/assets/img/icon_bed.svg';
import { ReactComponent as FlightIcon } from 'app/assets/img/icon_plane.svg';
import { ReactComponent as LeadingIcon } from 'app/assets/img/iconLeading.svg';
import { ReactComponent as ArrowRightIcon } from 'app/assets/img/right_arrow.svg';
import StyledCollapse, {
  CollapsePanelWrapper,
} from 'app/components/StyledCollapse';
import _ from 'lodash';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { renderReplaceText } from 'utils/helper';
import { selectTranslations } from '../App/slice/selectors';
import { COMBO_HOLIDAY_TYPES, formatDate } from '../BookingMask';
import { calculateHotelNights } from '../BookingMask/bookingMask.helpers';
import DialogFlightInformation from './DialogFlightInformation';
import { usePassengerCount } from './hooks/usePassengerCount';
interface IFlightInformationProps {
  flightInfo: any;
  comboInfo: any;
  hotelInfo?: any;
  dataAirports?: any;
  dataPassenger?: any;
}
const FALLBACK_IMAGE = Images.ImgBanner;
const FlightInformation: React.FC<IFlightInformationProps> = props => {
  const {
    flightInfo: dataFlight,
    comboInfo: dataCombo,
    hotelInfo: dataHotels,
    dataAirports,
    dataPassenger,
  } = props;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const translations = useSelector(selectTranslations);
  const [isShowInfo, setIsShowInfo] = useState<boolean>(false);
  const checkin = searchParams.get('checkin') ?? '';
  const checkout = searchParams.get('checkout') ?? '';
  const room = parseInt(searchParams.get('room') || '0', 10);
  const comboType =
    searchParams.get('comboType') ?? COMBO_HOLIDAY_TYPES.FLIGHT_TICKET;
  const hotelNights =
    (comboType === COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL_TICKET ||
      comboType === COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL) &&
    calculateHotelNights(checkin, checkout);
  const formatShortAirport = (
    a?: { code?: string; name?: string },
    isReturnObject: boolean = false,
  ) => {
    const cityName =
      dataAirports?.find(el => el.code === a?.code)?.cityName || '';
    const nameAirport =
      cityName && a?.code
        ? `${cityName} (${a.code})`
        : cityName || a?.code || '';
    if (isReturnObject) {
      return {
        cityName,
        nameAirport,
        a,
      };
    }
    return nameAirport;
  };
  const { totalAdultAndChild } = usePassengerCount(dataPassenger);

  const itinerary = dataFlight?.[0]?.trip?.listItinerary?.[0] ?? {};
  const departure = itinerary?.departureInfo;
  const arrival = itinerary?.arrivalInfo;
  const onCloseDialog = () => {
    setIsShowInfo(false);
  };
  const onClickViewDetailFlight = () => {
    setIsShowInfo(true);
  };
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.onerror = null;
    e.currentTarget.src = FALLBACK_IMAGE;
  };
  return (
    <BoxContainerCollapse>
      <StyledCollapse defaultActiveKey="">
        <CollapsePanelWrapper
          className="collapseItem"
          key={1}
          header={
            <div className="boxLeftHeaderCollapse">
              <div className="boxIcon">
                <FlightIcon width={20} height={20} />
              </div>
              <div>
                <Title>
                  {formatShortAirport(departure)}&nbsp;&nbsp;
                  <i
                    className={`fa-solid ${
                      dataFlight?.listFlight?.length > 1
                        ? 'fa-arrow-right-arrow-left'
                        : 'fa-arrow-right'
                    }`}
                    style={{ fontSize: 12 }}
                  />
                  &nbsp;&nbsp;
                  {formatShortAirport(arrival)}
                </Title>
                <SubTitle>
                  {
                    translations?.[
                      dataFlight?.length > 1
                        ? 'b2b.txt.roundTrip'
                        : 'b2b.txt.oneWay'
                    ]
                  }
                </SubTitle>
              </div>
            </div>
          }
        >
          <div className="boxContentCollapse">
            {dataFlight?.map((flight, index) => {
              const trip = flight?.trip || flight;
              const itinerary = trip?.listItinerary[0];
              let selectedPricing = flight?.pricing;
              const cabinName =
                selectedPricing?.segmentFare?.[0]?.cabin?.name || '';
              return (
                <ItemLeg key={index}>
                  <div className="txtLeg">
                    {index === 0
                      ? translations?.['b2b.txt.departureLeg']
                      : translations?.['b2b.txt.returnLeg']}
                  </div>
                  <div className="legContent">
                    <span>
                      {formatDate(moment(itinerary.flightDate), translations)}
                    </span>
                    &nbsp;|&nbsp;
                    <span>{cabinName}</span>
                    &nbsp;|&nbsp;
                    <span>
                      {moment(itinerary?.departureInfo?.datetime).format(
                        'HH:mm',
                      )}
                      &nbsp;
                      <i
                        className={`fa-solid fa-arrow-right icon`}
                        style={{
                          fontSize: 12,
                        }}
                      />
                      &nbsp;
                      {moment(itinerary?.arrivalInfo?.datetime).format('HH:mm')}
                    </span>
                  </div>
                </ItemLeg>
              );
            })}
            <div className="seeDetail" onClick={onClickViewDetailFlight}>
              {translations?.['b2c.text.see-detail']} &nbsp;
              <ArrowRightIcon />
            </div>
          </div>
        </CollapsePanelWrapper>
      </StyledCollapse>
      {!_.isEmpty(dataHotels) && (
        <StyledCollapse defaultActiveKey="">
          <CollapsePanelWrapper
            style={{ marginTop: 10 }}
            className="collapseItem"
            key={1}
            header={
              <div className="boxLeftHeaderCollapse">
                <div className="boxIcon">
                  <BedIcon width={20} height={20} />
                </div>
                <div>
                  <Title>
                    {renderReplaceText(
                      translations?.['b2b.txt.hotelInLocation'],
                      {
                        name: formatShortAirport(arrival, true)?.cityName,
                      },
                    )}
                  </Title>
                  <SubTitle>
                    {' '}
                    {renderReplaceText(translations?.['b2b.txt.roomAndNight'], {
                      room: room,
                      night: hotelNights,
                    })}
                  </SubTitle>
                </div>
              </div>
            }
          >
            <div className="boxContentCollapse">
              <BookingInfo>
                {`${formatDate(moment(checkin), translations)} - ${formatDate(
                  moment(checkout),
                  translations,
                )} | ${totalAdultAndChild} ${
                  translations?.['b2b.txt.passenger']
                }`}
              </BookingInfo>
              {dataHotels?.map(item => {
                const hotel = item?.hotel;
                const firstRoom = item?.roomTypes?.[0];
                const roomType = firstRoom?.roomType;
                return (
                  <HotelCard key={item.hotel.id}>
                    <HotelName>{hotel?.name || ''}</HotelName>
                    <div className="d-flex gap-3">
                      <HotelImage
                        src={roomType?.images?.[0]?.url || FALLBACK_IMAGE}
                        alt="hotel"
                        onError={handleImageError}
                      />
                      <HotelContent>
                        <RoomName>{`${
                          roomType?.name || ''
                        } x ${room}`}</RoomName>
                        <RoomMeta>
                          {' '}
                          {[
                            roomType.roomSize && `${roomType.roomSize}m2`,
                            roomType.viewType,
                          ]
                            .filter(Boolean)
                            .join(', ')}
                        </RoomMeta>
                      </HotelContent>
                    </div>
                  </HotelCard>
                );
              })}
            </div>
          </CollapsePanelWrapper>
        </StyledCollapse>
      )}
      {comboType !== COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL && (
        <StyledCollapse defaultActiveKey="">
          <CollapsePanelWrapper
            style={{ marginTop: 10 }}
            className="collapseItem"
            key={1}
            header={
              <div className="boxLeftHeaderCollapse">
                <div className="boxIcon">
                  <LeadingIcon width={20} height={20} />
                </div>
                <div>
                  <Title>
                    {translations?.['b2b.txt.sunWorldParkTicket'] || ''}
                  </Title>
                </div>
              </div>
            }
          >
            <div className="boxContentCollapse">
              {dataCombo?.map(item => {
                return (
                  <div className="boxContentCombo" key={item?.ticket?.id}>
                    <img
                      src={item?.ticket?.imageUrl || Images.ImgBanner}
                      alt=""
                      className="combo-img"
                      onError={e => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = Images.ImgBanner;
                      }}
                    />
                    <div className="infoCombo">
                      <div className="titleCombo">
                        {item?.ticket?.name || item?.ticket?.otaProductCode}
                      </div>
                      <div className="textQuantity">{`${translations?.[
                        'b2b.txt.quantityTicket'
                      ]?.replace('${quantity}', +totalAdultAndChild)}`}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </CollapsePanelWrapper>
        </StyledCollapse>
      )}
      {isShowInfo && (
        <DialogFlightInformation
          flights={dataFlight || []}
          isShow={isShowInfo}
          onCloseDialog={onCloseDialog}
        />
      )}
    </BoxContainerCollapse>
  );
};
export default FlightInformation;
const BoxContainerCollapse = styled.div`
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 20px;
  .collapseItem {
    border-radius: 8px !important;
    border: 1px solid #e5e5e5;
    overflow: hidden;
    .ant-collapse-header {
      padding-right: 12px !important;
      padding-top: 0px !important;
      height: 50px;
      background: #f2f2f2;
      .ant-collapse-arrow {
        right: 10px !important;
      }
    }
  }
  .boxLeftHeaderCollapse {
    height: 50px;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .boxIcon {
    background: var(--color-gradient);
    min-height: 50px;
    height: 100%;
    min-width: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .boxContentCollapse {
    background: #fff;
  }
  .seeDetail {
    color: var(--color-4);
    padding-left: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    &:hover {
      opacity: 0.8;
    }
  }
  .boxContentCombo {
    background: #f2f2f2;
    border-radius: 8px;
    padding: 10px;
    margin-left: 10px;
    margin-right: 10px;
    display: flex;
    align-items: center;
  }
  .combo-img {
    width: 36px;
    height: 36px;
    object-fit: cover;
    border-radius: 8px;
  }
  .infoCombo {
    margin-left: 10px;
  }
  .titleCombo {
    font-size: 12px;
    font-weight: 600;
  }
  .textQuantity {
    font-size: 12px;
  }
`;
const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
`;
const SubTitle = styled.div`
  font-size: 10px;
`;
const ItemLeg = styled.div`
  display: flex;
  margin-bottom: 6px;
  padding: 0 10px;
  font-size: 14px;
  align-items: center;
  .txtLeg {
    color: var(--color-9);
    min-width: 80px;
    font-weight: 600;
    flex-shrink: 0;
  }
  .legContent {
    display: inline;
    line-height: 1.4;
  }
  .icon {
    display: inline;
    margin: 0 4px;
    font-size: 12px;
    vertical-align: middle;
  }
`;
const BookingInfo = styled.div`
  font-size: 14px;
  margin-bottom: 6px;
  margin-left: 10px;
  margin-right: 10px;
`;
const HotelCard = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: #f8f8f8;
  border-radius: 8px;
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
  margin-left: 10px;
  margin-right: 10px;
`;
const HotelImage = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 6px;
  object-fit: cover;
  flex-shrink: 0;
`;
const HotelContent = styled.div`
  flex: 1;
  min-width: 0;
`;
const HotelName = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #000;
`;
const RoomName = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #222;
`;
const RoomMeta = styled.div`
  font-size: 12px;
  color: #777;
`;
